import { useState } from "react";
import { useForm } from "react-hook-form";

import { updateAnswerDetail } from "services";
import { useSnackbar } from "providers/SnackbarProvider";
import { useConfirmDialogExit } from "hooks";
import { DetailAnswer } from "interfaces";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import {
  buttonSaveUpdate,
  formChangeTitleAnswer,
  modalEditPinnedAnswerSubTitle,
  modalEditPinnedAnswerTitle,
  snackbarSeveritySuccess,
  snackbarSummarySuccessUpdateAnswerSubTitle,
  snackbarSummarySuccessUpdateAnswerTitle,
} from "_constants";
import { FormChangeTitleAnswer } from "components/form/FormChangeTitleAnswer";
import { useAppDispatch } from "store/store";
import {
  setCurrentAnswer,
  setTitleAnswer,
} from "store/slicer/GestioneSaveAnswerSlice";

export const ModalRenameAnswer = ({
  answer,
  showDialog = false,
  onClose,
}: {
  answer: DetailAnswer;
  showDialog: boolean;
  onClose: Function;
}) => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(showDialog);
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();

  const { handleSubmit, control } = useForm({
    defaultValues: {
      id: answer.id,
      title: answer.title,
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  const onSubmit = (formData: any) => {
    updateAnswerDetail(formData)
      .then((_) => {
        showSnackbar({
          severity: snackbarSeveritySuccess,
          summary: snackbarSummarySuccessUpdateAnswerTitle,
          detail: snackbarSummarySuccessUpdateAnswerSubTitle,
          life: 5000,
        });
        resetFormState();
        dispatch(setCurrentAnswer({ ...answer, title: formData.title } as any));
        dispatch(setTitleAnswer({ id: answer.id, title: formData.title }));
        onClose();
      })
      .catch((_) => {});
  };

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    control._reset();
    setVisible(false);
    onClose();
  };

  const stopPropagation = (e: any) => {
    e.stopPropagation();
  };

  return (
    <div onClick={(e) => stopPropagation(e)}>
      <SingleStepDialog
        onHideCallback={handleDismiss}
        height="auto"
        width="700px"
        header={
          <SingleStepHeaders
            title={modalEditPinnedAnswerTitle}
            subtitle={modalEditPinnedAnswerSubTitle}
          />
        }
        body={
          <SingleStepBody
            content={
              <form
                id={formChangeTitleAnswer}
                onSubmit={handleSubmit(onSubmit)}
                className="width-100 padd-top-4"
              >
                <FormChangeTitleAnswer control={control} />
              </form>
            }
          />
        }
        footer={
          <SingleStepFooter
            dismiss={handleDismiss}
            form={formChangeTitleAnswer}
            labelSubmit={buttonSaveUpdate}
          />
        }
        display={visible}
        setVisible={setVisible}
      />
    </div>
  );
};
